import React from 'react';
import { HotTable } from '@handsontable/react';
import { getImageURL } from '../../../../util/getImage';
import { DESIRED_COLUMNS } from './constants';

const ManMadeHeritageTable = React.forwardRef(({ 
  tableData, 
  onEditClick, 
  onImageClick,
  onDeleteClick
}, ref) => {
  // Custom renderer for action buttons
  const actionColumnRenderer = (instance, td, row, col, prop, value, cellProperties) => {
    td.innerHTML = '';
    
    // Get the alias from the table data for this row
    const rowData = tableData[row];
    const aliasIndex = DESIRED_COLUMNS.indexOf('alias');
    const recordAlias = rowData && rowData[aliasIndex];
    
    // Create edit button
    const editButton = document.createElement('button');
    editButton.innerHTML = 'Edit';
    editButton.className = 'edit-btn';
    editButton.style.marginRight = '5px';
    editButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (recordAlias) {
        onEditClick(recordAlias);
      }
    });
    
    // Create delete button
    const deleteButton = document.createElement('button');
    deleteButton.innerHTML = 'Delete';
    deleteButton.className = 'delete-btn';
    deleteButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (recordAlias && onDeleteClick) {
        onDeleteClick(recordAlias);
      }
    });
    
    td.appendChild(editButton);
    td.appendChild(deleteButton);
    td.style.textAlign = 'center';
    
    return td;
  };

  const hotSettings = {
    data: tableData,
    colHeaders: [...DESIRED_COLUMNS, 'Actions'],
    rowHeaders: false, // Remove row numbers
    height: "auto",
    licenseKey: "non-commercial-and-evaluation",
    contextMenu: true,
    sort: false, // Disable sorting
    columnSorting: false, // Disable column sorting
    manualColumnResize: true, // Allow manual column resize
    manualRowResize: true, // Allow manual row resize
    cells: (row, col) => {
      // Make masterlist_alias and alias readonly
      if (col === 1 || col === 2) { // masterlist_alias and alias columns
        return { readOnly: true };
      }
      return {};
    },
    columns: [
      // Map each desired column
      ...DESIRED_COLUMNS.map((columnName, index) => {
        const baseConfig = {
          data: index,
          title: columnName,
          readOnly: columnName === 'masterlist_alias' || columnName === 'alias'
        };
        
        // Add special renderer for image_alias column
        if (columnName === 'image_alias') {
          baseConfig.renderer = (instance, td, row, col, prop, value, cellProperties) => {
            // Clear the cell first
            td.innerHTML = '';
            
            if (value) {
              const img = document.createElement('img');
              img.src = getImageURL(value);
              img.style.width = '50px';
              img.style.height = '50px';
              img.style.cursor = 'pointer';
              img.style.display = 'block';
              img.addEventListener('click', () => onImageClick(getImageURL(value)));
              td.appendChild(img);
            } else {
              td.textContent = 'No Image';
            }
            return td;
          };
        }
        
        return baseConfig;
      }),
      // Add Actions column
      {
        data: DESIRED_COLUMNS.length,
        title: 'Actions',
        width: 120,
        renderer: actionColumnRenderer
      }
    ]
  };

  return <HotTable ref={ref} {...hotSettings} />;
});

ManMadeHeritageTable.displayName = 'ManMadeHeritageTable';

export default ManMadeHeritageTable;
